import React from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import './OEEMetricas.css';

const DASHBOARD_UID = 'tdsn5sr'; // TODO: Reemplazar con el UID real del dashboard de OEE
const DASHBOARD_SLUG = 'oee-metricas'; // TODO: Reemplazar con el slug real del dashboard de OEE
const THEME = 'dark';
const FROM = 'now-6h';
const TO = 'now';

const OEEMetricas = () => {
  const { t } = useLanguage();
  const GRAFANA_BASE = import.meta.env.VITE_API_URL;
  const iframeUrl = `${GRAFANA_BASE}/d/${DASHBOARD_UID}/${DASHBOARD_SLUG}?orgId=1&kiosk&theme=${THEME}&from=${FROM}&to=${TO}`;

  return (
    <div className="oee-metricas">
      <header className="oee-header">
        <h1>{t.produccion?.oeeMetricas?.title || '📊 Métricas OEE'}</h1>
        <p>{t.produccion?.oeeMetricas?.description || 'Métricas OEE (Overall Equipment Effectiveness)'}</p>
      </header>
      <div className="oee-iframe-container">
        <iframe
          src={iframeUrl}
          title="Dashboard Grafana - Métricas OEE"
          className="oee-grafana-iframe"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};

export default OEEMetricas;








